import React from "react";

var SettingsIcon = function SettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.286 14.458L20.73 13.15c.047-.377.08-.759.08-1.149s-.033-.772-.08-1.149l1.556-1.308c.739-.621.93-1.698.451-2.544l-1.129-1.997a1.938 1.938 0 0 0-2.382-.873l-1.893.725a8.783 8.783 0 0 0-1.943-1.158l-.33-2.024C14.902.707 14.085 0 13.128 0h-2.257C9.914 0 9.098.707 8.94 1.671l-.33 2.024c-.7.299-1.349.694-1.943 1.158l-1.894-.724a1.938 1.938 0 0 0-2.382.873L1.262 6.999a2.029 2.029 0 0 0 .452 2.543L3.27 10.85c-.048.378-.08.76-.08 1.15 0 .39.033.772.08 1.149l-1.556 1.308a2.029 2.029 0 0 0-.451 2.544l1.129 1.997a1.938 1.938 0 0 0 2.382.873l1.893-.725a8.783 8.783 0 0 0 1.943 1.158l.33 2.024c.158.965.975 1.672 1.932 1.672h2.257c.957 0 1.774-.707 1.931-1.671l.33-2.024a8.738 8.738 0 0 0 1.943-1.158l1.893.725a1.94 1.94 0 0 0 2.383-.873l1.128-1.997a2.029 2.029 0 0 0-.451-2.544zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
  }));
};

SettingsIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
SettingsIcon.defaultProps.solid = true;
export default SettingsIcon;